<script setup>
</script>

<template>
    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M16 12L10 18V6L16 12Z"></path>
    </svg>
</template>